const doodle = require('./doodle').default;
module.exports = doodle;
